const formatDecimal = value => {
  if (value === null ||
    value === undefined ||
    value === '') return null

  return (value).toLocaleString(
    undefined,
    { minimumFractionDigits: 2 }
  )
}

export default formatDecimal
